// extracted by mini-css-extract-plugin
export default {"scrollbarHidden":"scrollbarHidden___TkZnO","a11yHeading":"a11yHeading___mCCeg","visuallyHidden":"visuallyHidden___V3ABv"};